
/**
 * ceramic-offer.js
 * Parcours ceramic bearing event offers
 * Shopify Impulse theme / AJAX cart drawer
 *
 * Offer 1: ceramic_offer = "1"
 * Offer 2: ceramic_offer = "event2"
 *
 * Adds the corresponding upgrade when a qualifying
 * wheel product is present in the cart.
 *
 * Only one ceramic upgrade per cart.
 */

(function () {

  // CONFIGURATION
  const UPGRADE_VARIANTS = {
    '1': 56705947042175,       // Original offer
    '2': 58904549163391   // KB offer
  };

  const UPGRADE_IDS = Object.values(UPGRADE_VARIANTS);

  // Use Shopify's locale-aware cart URL
  const CART_ROOT = window.Shopify?.routes?.root || '/';

  async function cartRequest(path, options = {}) {
    const response = await fetch(CART_ROOT + path, {
      credentials: 'same-origin',
      ...options
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data.description ||
        data.message ||
        'Shopify cart request failed'
      );
    }

    return data;
  }

  async function getCart() {
    return cartRequest('cart.js');
  }

  async function updateCartAttributes(attrs) {
    return cartRequest('cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: attrs
      })
    });
  }

  async function addUpgradeVariant(variantId, offerSource) {
    return cartRequest('cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: {
          '_offer_source': offerSource
        }
      })
    });
  }

  function hasWheelLineItem(cart) {
    return (cart.items || []).some(item => {
      const properties = item.properties || {};

      return (
        properties._is_wheel === '1' ||
        properties.is_wheel === '1'
      );
    });
  }

  function hasUpgradeLineItem(cart) {
    return (cart.items || []).some(item =>
      UPGRADE_IDS.includes(item.variant_id)
    );
  }

  let isRunning = false;

  async function maybeAddCeramicUpgrade() {

    if (isRunning) return;
    isRunning = true;

    try {
      const cart = await getCart();

      const offerState =
        (cart.attributes || {}).ceramic_offer;

      // Determine which upgrade belongs to the offer
      const upgradeVariantId =
        UPGRADE_VARIANTS[offerState];

      // No active offer or offer already applied
      if (!upgradeVariantId) return;

      // Only apply to qualifying wheel products
      if (!hasWheelLineItem(cart)) return;

      // Prevent duplicate ceramic upgrades
      if (hasUpgradeLineItem(cart)) return;

      console.log(
        '[ceramic-offer] Applying offer:',
        offerState
      );

      // Add the corresponding upgrade product
      await addUpgradeVariant(
        upgradeVariantId,
        offerState
      );

      // Record successful application and source
      await updateCartAttributes({
        ceramic_offer: 'applied',
        ceramic_offer_source: offerState
      });

      // Refresh Impulse cart drawer
      document.dispatchEvent(
        new CustomEvent('cart:build')
      );

      console.log(
        '[ceramic-offer] Upgrade successfully added'
      );

    } catch (error) {
      console.error(
        '[ceramic-offer] Error:',
        error
      );
    } finally {
      isRunning = false;
    }
  }

  // Impulse AJAX add-to-cart event
  document.addEventListener(
    'ajaxProduct:added',
    maybeAddCeramicUpgrade
  );

  // Cart update fallback
  document.addEventListener(
    'cart:updated',
    maybeAddCeramicUpgrade
  );

  // Initial page load
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      maybeAddCeramicUpgrade
    );
  } else {
    maybeAddCeramicUpgrade();
  }

})();
